
import { makeStateKey } from "@angular/core";

export const CSP_NONCE_KEY = makeStateKey<string>('CSP_NONCE_KEY');